import { Navigate } from "react-router-dom";

const ForgotPassword = () => <Navigate to="/login?view=forgot" replace />;

export default ForgotPassword;
